// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfs_a bhr_wj bhr_ss bhr_xl"};